import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import { KeyboardBackspace } from '@mui/icons-material';
import { default as React } from "react";
import {  useNavigate } from "react-router-dom";
import * as styleGlobal from "../infra/styleGlobal";
import { Text, View } from "./index";
import StyleSheet from "./StyleSheet";
export function goBack(history) {

  if (history.length <= 2) {
    // history.goBack();
    history.replace({
      pathname: "/",
    })
  } else {
    history.goBack();
  }
}



const TitleBar = (props = {}) => {

  let { to = {}, marginLateral = 0, leftComponent, titulo, children, showBack = true, onClickBack, } = props;

  let history = useNavigate();
  function returnBody() {
    return (
      <View style={{ flex: 1, alignSelf: 'stretch' }} >
        <View className={"toColumnMob"} style={{ flexDirection: 'row', flex: 1 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'center', padding: 10, paddingLeft: 0 }}>
            {showBack &&
              <IconButton style={{ height: 10, width: 15, alignSelf: 'center', marginLeft: 10, marginRight: 10 }}
                onClick={() => {
                  if (onClickBack)
                    onClickBack();
                  else {
                    goBack(history);
                  }
                }}>
                <KeyboardBackspace style={{ color: styleGlobal.preto }} />
              </IconButton>
            }
            <Text style={{ fontWeight: 'bold', alignSelf: 'center', marginLeft: 5, fontSize: 14, flex: 1 }}>{titulo}</Text>
          </View>
          {leftComponent != null &&
            <View className={"toColumnMob"} style={{ flexDirection: 'row', marginRight: 5, flex: 1, justifyContent: 'flex-end' }}>
              {leftComponent}
            </View>
          }
        </View>
        <View style={{ minHeight: "75vh", borderRadius: 10, padding: 15, marginLeft: marginLateral, marginRight: marginLateral, marginTop: 5, backgroundColor: styleGlobal.color3 }}>
          {children}
        </View>
      </View >
    )
  }
  return (returnBody())
};
var styles = StyleSheet.create({
  fragment2: { flexDirection: "row", zIndex: 888 },
})

export const gsUI = theme => ({
  lbltab: {
    color: "#444444",
    fontSize: 17,
    textTransform: "none",
    // fontWeight: 'bold',
    [theme.breakpoints.down(styleGlobal.breakMobile)]: {
      fontSize: 12
    },
  },
  aaa: {
    [theme.breakpoints.down(styleGlobal.breakMobile)]: {
      left: 0,
      right: 0,
      width: "95vw !important",
    },
  },
});
export default (withStyles(gsUI)(TitleBar));


 //exemplo de tab
/*

 this.tabs =  //tem q ser antes do state
 [
   { nome: "Categorias e Produtos", tela: "teste1", index: 0 },
   { nome: 'Configurações de Variações e Opções', tela: "teste2", index: 1 },
   { nome: 'Grupos de Produtos/Horários', tela: "teste3", index: 2 },
 ]
 this.state = { user: {}, index: actions.tabsTelas(this) || 0, };
}
   <View>
        <TitleBar showBack={false} titulo={"Produtos e Categorias"}
          tabs={this.tabs}
          pushTo={(index) => { actions.pushToTab({ index, path: "filial/" + id_filial + "/empresa/" + id_empresa + "/catprods/", componente: this }); this.setState({ index: index }) }}
          tabvalue={index}
        >
          {index == 0 &&
            <Text>0</Text>
          }
             {index == 1 &&
            <Text>1</Text>
          }

          ...etc
*/